import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Breadcrumbs({ links = [] }) {
  return (
    <div className="breadcrumbs-block">
      {links.map((link, index) => (<>{index > 0 ? <span className="breadcrumbs-delimiter">/</span> : null}<NavLink key={index} to={link.href} className="breadcrumbs-link">{link.name}</NavLink></>))}
    </div>
  );
}
